<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/manage-service" class="vx-row">
            <feather-icon icon="ArrowLeft" svgClasses="text-dark" />
            <h3>Back</h3>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- <router-link to="/help" class="vx-row"> </router-link>
    <h3>Add Plan</h3> -->
    <div class="chart-container">
      <h3>Add Plan</h3>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <p>Plan Code</p>
            <v-select
              label="planCode"
              :options="manageLists"
              v-model="ticket.planCode"
              @input="planlist"
              placeholder="Select Plan Code"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="min-w-200 w-full mb-2"
            />
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <vs-input
              class="mt-4"
              label="Plan Description"
              placeholder="Select Plan Code"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="ticket.problemCode"
              readonly
            />
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <vs-input
              label="Charge Code"
              placeholder="Select Plan Code"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="ticket.chargecode"
              readonly
            />
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <vs-input
              label="Price"
              placeholder="Select Plan Code"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="ticket.price"
              readonly
            />
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <div class="radio_button" v-if="this.ticket.type === 'Y'">
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                :value="isSelector"
                v-model="ticket.wallect"
              >
                Wallect
              </vs-checkbox>
            </div>
            <div v-if="ticket.wallect">
              <vs-input
                placeholder="Select Plan Code"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="ticket.wallectAmount"
                readonly
              />
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
      <div v-if="this.ticket.type === 'Y'">
        <div v-if="ticket.wallect == false" class="button_content">
          <paystack
            :amount="ticket.price * 100"
            :email="userInfo.clientData.email"
            :paystackkey="paystackKey"
            :reference="reference"
            :callback="processPayment"
            :close="close"
            :embed="false"
            currency="NGN"
            class="pay-nows"
          >
            Online Pay
          </paystack>
        </div>
      </div>
      <div v-if="ticket.wallect" class="button_content">
        <vs-button class="create_utton2" @click="updatePlan">
          Wallect Pay
        </vs-button>
      </div>
      <div v-if="this.ticket.type === 'N'" class="button_content">
        <vs-button class="create_utton2" @click="updatePlan">
          Add Plan
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getTicketSubCategory, getTicketList } from "@/services/dashboard";
import moment from "moment";
import { BASE_URL, PAYSTACK_KEY } from "../../services";
import paystack from "vue-paystack";
import vSelect from "vue-select";
import { mapState } from "vuex";
const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  teamCode: "",
  status: "",
  title: "",
  planDescription: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MMMM YYYY"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null,
  wallect: false,
  isSelector: ""
};

export default {
  props: ["clientId", "refresh"],
  data() {
    return {
      paystackKey: PAYSTACK_KEY,
      ticketId: "",
      ticketCreatePopup: false,
      cancelTicketPopup: false,
      ticket: { ...ticketObj },
      bulkUploads: {
        file: null
      },
      ticketPopup: false,
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i"
      },
      subCategoryItem: [],
      teamUsersItem: [{ id: null, username: "all" }],
      cancelObj: {
        status: "",
        resolutionDescription: "",
        ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/"
      },
      CtemplateData: {}
    };
  },

  components: {
    "v-select": vSelect,
    paystack
  },
  computed: {
    userInfo() {
      return this.$store.getters["auth/getUser"];
    },
    ticketList() {
      return this.$store.getters["dashboard/getTicketList"];
    },
    manageLists() {
      return this.$store.getters["dashboard/getManageServiceList"];
    },
    template() {
      return this.$store.getters["dashboard/getTicketTemplate"];
    },
    ...mapState({
      subCategoryItem: state => state.entity.ticketSubcategory,
      teamUsers: state => state.dashboard.teamUsers,
      ticketById: state => state.dashboard.ticketById,
      ticketViewById: state => state.dashboard.ticketViewById
    })
  },

  methods: {
    planlist() {
      console.log(this.ticket.planCode, "test12");

      this.ticket.problemCode = this.ticket.planCode.planDescription;
      this.ticket.chargecode = this.ticket.planCode.chargeCycle;
      this.ticket.price = this.ticket.planCode.price;
      this.ticket.type = this.ticket.planCode.isPrepaid;
      this.ticket.wallectAmount = this.userInfo.clientData.walletAmount;
    },
    async getEntityList() {
      try {
        const payload = {
          id: this.userInfo.firstTimeLogInRemaining,
          clientId: this.userInfo.clientId,
          clientServiceId: this.userInfo.clientOrdersData[0].clientServiceId,
          planPoId: this.userInfo.clientOrdersData[0].planPoId
        };
        await this.$store.dispatch("dashboard/getManageServiceList", payload);
        console.log(this.manageLists.planData.id, "test234");
      } catch (e) {}
    },
    getDate(date) {
      if (date) return moment(date.join("/")).format("DD MMMM YYYY");
      return null;
    },
    async getUserByTeam() {
      try {
        this.$store.dispatch("dashboard/getUserByTeam", this.ticket.teamCode);
      } catch (e) {}
    },
    async getTickets() {
      try {
        const response = await getTicketList(this.userInfo.clientId);
        this.$store.dispatch("dashboard/getTicketList", response.data);
      } catch (error) {
        console.log(
          "something went to wrong while retrieving client tickets:",
          error
        );
      }
    },
    async getSubCategory(categoryId) {
      try {
        const response = await getTicketSubCategory(categoryId);
        this.subCategoryItem = response.data.subCategory;
      } catch (e) {
        console.log(e);
      }
    },

    async ticketTemplate() {
      try {
        await this.$store.dispatch("dashboard/setTicketTemplate");
        this.getTicketById();
      } catch (error) {
        console.log(
          "something went to wrong while retrieving client tickets:",
          error
        );
      }
    },
    async getTicketById() {
      try {
        await this.$store.dispatch("dashboard/setTicketById", {
          clientId: this.clientId,
          id: this.ticketId
        });
        await this.getSubCategory(this.ticketById.problemCode);
        await this.$store.dispatch(
          "dashboard/getUserByTeam",
          this.ticketById.teamId
        );
        this.ticket.assignedTo = this.ticketById.teamUserId;
        this.ticket.priority = this.ticketById.priority;
        this.ticket.problemCode = this.ticketById.problemCode;
        this.ticket.subCategory = this.ticketById.subCategoryes;
        this.ticket.status = this.ticketById.status;
        this.ticket.description = this.ticketById.lastComment;
        this.ticket.sourceOfTicket = this.ticketById.sourceOfTicket;
        this.ticket.teamCode = this.ticketById.teamId;

        this.refresh = false;
      } catch (e) {}
    },
    async updatePlan() {
      let payload = {
        billAlign: false,
        planCode: this.ticket.planCode.id,
        Newplanprepaid: this.ticket.type,
        changePlanDetail:
          this.userInfo.clientOrdersData[0].planDescription +
          "to" +
          this.ticket.planCode.planDescription,
        clientServiceId: this.userInfo.clientServices[0].id,
        clientId: this.userInfo.clientId,
        isNewplan: false,
        oldplanId: this.userInfo.clientOrdersData[0].pdid,
        oldplanprepaid: this.userInfo.clientOrdersData[0].isPrepaid,
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        start_date: moment().format("DD MMMM YYYY"),
        contractPeriod: this.ticket.planCode.contractPeriodId,
        paytermCode: this.ticket.planCode.chargeCycle,
        planPoId: 0,
        dealPoId: 0,
        disconnectionDate: moment().format("DD MMMM YYYY"),
        disconnectReason: "Not Interested"
      };
      try {
        await this.$store.dispatch("dashboard/updatePlan", {
          clientId: this.userInfo.clientOrdersData[0].id,
          data: payload
        });
        this.$router.push(`/`);
        //this.getTickets();
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    this.ticketTemplate();
    this.getEntityList();
  },
  watch: {
    ticketCreatePopup(newValue) {
      if (newValue) {
        this.ticketTemplate();
        this.ticket.ticketDate = moment().format("DD MMMM YYYY hh:mm:ss a");
      }
    },
    "ticket.problemCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getSubCategory(this.ticket.problemCode);
      }
    },
    "ticket.teamCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getTeamUsers(this.ticket.teamCode);
      }
    },
    "ticket.dueTime"(newValue, oldValue) {
      debugger;
    },
    ticketPopup(newval) {
      if (newval) {
        this.ticketTemplate();
      }
    },
    refresh(val) {
      this.getTickets();
    }
  }
};
</script>

<style>
.chart-container {
  background: #fff;
  padding: 20px;
  margin: 0 1rem;
  border-radius: 20px;
}
.invoice-card {
  background: linear-gradient(135deg, #6572bb 0%, #2b3674 100%);
  width: 100%;
  padding: 20px;
  color: #ffffff;
  border-radius: 16px;
}
.button_content {
  display: flex;
  justify-content: space-evenly;
}
.create_utton1 {
  width: 200px;
  background-color: #fff;
  color: red;
  border: 1px solid red;
  font-weight: bold;
  height: 40px;
  margin-left: 140px;
  margin-top: 50px;
}
.create_utton2 {
  width: 200px;
  background-color: #30a852;
  font-weight: bold;
  height: 40px;
  color: #fff;
  border: 1px solid #30a852;
  border-radius: 5px;
  margin-right: 140px;
  margin-top: 50px;
}
.pay-nows {
  width: 200px;
  background-color: #30a852;
  font-weight: bold;
  height: 40px;
  color: #fff;
  border: 1px solid #30a852;
  border-radius: 5px;
  margin-right: 140px;
  margin-top: 50px;
}
.right-width {
  width: 420px;
  border-radius: 4px;
}
.left-width {
  width: 420px;
  border-radius: 4px;
}
.drop {
  /* height: 200px; */
  width: 50rem;
}
/* .texts {
  height: 200px;
} */
.v-select {
  width: 420px;
}
/* .vs-input {
  width: 420px;
  height: 38px;
  border-radius: 15px;
  
} */
</style>
